import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalcCeAverage } from '../parts/CalcCeAverage';
import { CalcCeChart } from '../parts/CalcCeChart';
import { CalcCeDataTable } from '../parts/CalcCeDataTable';
import { CalcCeUploadForm } from '../parts/CalcCeUploadForm';
import './CalcCe.css';
import { useUserContext } from '../../contexts/UserContext';
import { CalcCeResult, ChartCe, ResultCe } from '../parts/CalcCeData';

export const CalcCe: React.FC = () => {
    const userContext = useUserContext();
    const [calcResult, setCalcResult] = useState<CalcCeResult>({});

    const getChartCe = () => {
        const ret: ChartCe = {
            chartCe: [],
            chartCeAvg1: [],
            chartCeAvg2: [],
            chartCeAvg3: [],
            chartCeAvg4: [],
        };
        if (calcResult?.resultListCe === undefined) {
            console.log('getChartCe: empty.');
            return ret;
        }
        console.log('getChartCe: calcResult?.resultListCe.length=' + calcResult?.resultListCe.length);
        calcResult?.resultListCe .forEach(element => {
            const dt: string = element.calculationDt === undefined ? "" : element.calculationDt.substring(0, 16);
            const dtTime: Date = new Date(dt);
            const ce: (number | null) = element.ce === undefined ? null : element.ce;
            const ceAvg1: (number | null) = element.ceAvg1 === undefined ? null : element.ceAvg1;
            const ceAvg2: (number | null) = element.ceAvg2 === undefined ? null : element.ceAvg2;
            const ceAvg3: (number | null) = element.ceAvg3 === undefined ? null : element.ceAvg3;
            const ceAvg4: (number | null) = element.ceAvg4 === undefined ? null : element.ceAvg4;
            // nullのデータがあると線が途切れるため、nullならグラフに表示しない
            if (ce !== null){
                ret.chartCe = ret.chartCe?.concat({x: dtTime, y: ce});
                ret.chartCeAvg1 = ret.chartCeAvg1?.concat({x: dtTime, y: ceAvg1});
                ret.chartCeAvg2 = ret.chartCeAvg2?.concat({x: dtTime, y: ceAvg2});
                ret.chartCeAvg3 = ret.chartCeAvg3?.concat({x: dtTime, y: ceAvg3});
                ret.chartCeAvg4 = ret.chartCeAvg4?.concat({x: dtTime, y: ceAvg4});
            }
        });
        //console.log(ret.ceAvg2);
        // console.log('getChartCe: ret.dt.length=' + ret.dt.length);

        return ret;
    }

    if (!userContext.isLoggedIn) {
        userContext.logout();
        window.location.href = '/';
    }

    userContext.availableFunction(userContext.idToken, {
        onFuncSuccess: function (funcList) {
            let availableflg;
            // availableflg = funcList.some((funcList) => funcList.functionId == target);
            availableflg = userContext.isAvailableFunc('calcce', funcList);
            if (!availableflg) {
                console.log('isAvailableFunc: FAILURE availableflg = ' + availableflg);
                userContext.logout();
                window.location.href = '/';
            } else {
                console.log('isAvailableFunc: SUCCESS availableflg = ' + availableflg);
            }
        },
        onFuncFailure: function (err) {
            console.log('availableFunction: FAILURE');
            userContext.logout();
            window.location.href = '/';
        }
    });


    return (
        <div className="CalcCe_content">
            <CalcCeUploadForm setCalcResult={setCalcResult}/>
            <CalcCeAverage calcResult={calcResult}/>
            <CalcCeChart charCe={getChartCe()}/>
            <CalcCeDataTable calcResult={calcResult}/>
        </div>
    );
};
